const sendMessage = (err, message) => {
  console.log(err, message)
  if (err || message) {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('android') !== -1) {
      if (ISTAY_TABLET_APP) {
        return ISTAY_TABLET_APP.webErrorCallback(err, message)
      }
    // } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
    //   if (window.webkit.messageHandlers.webErrorCallback) {
    //     return window.webkit.messageHandlers.webErrorCallback.postMessage(message)
    //   }
    // } else { // 안드로이드, IOS 가 아닌 경우 (더 조건을 추가해서 처리해도 됨)
    //   if (window && window.opener) {
    //     return window.opener.postMessage(err, message)
    //   }
    }
  }
}

export default sendMessage